export default __webpack_public_path__ + "static/landscapes-fourth-4a6399f4d6264bd2d465650a1db9c0a6.webp";